import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {FormArray, FormGroup} from '@angular/forms';
import {EquipmentEnums} from '@namespaces/equipment.namespace';

@Component({
    selector: 'app-apparatus-calibrations',
    template: `
        <ng-container *ngFor="let group of fbArray.controls; let i = index">
            <apparatus-card-calibration [form]="group" (remove)="onRemove(i)" [calibrationInterval]="verificationInterval">
            </apparatus-card-calibration>
        </ng-container>
        <app-form-group>
            <button type="button" class="button-transparent" (click)="onAdd()">
                <lib-icon type="card" [size]="12"></lib-icon>
                Добавить
                {{verificationStatus | calibrationLabel : 'поверку' : 'калибровку' : 'поверку/калибровку'}}
                оборудования
            </button>
            <app-calibration-info *ngIf="!fbArray.value.length" [verificationStatus]="verificationStatus"></app-calibration-info>
        </app-form-group>
    `
})

export class ApparatusCardCalibrationsComponent {
    @Input() fbArray: FormArray = new FormArray([]);

    @Input() verificationStatus: EquipmentEnums.VerificationStatus;
    @Input() verificationInterval: number;

    constructor(
        private cd: ChangeDetectorRef,
    ) {}

    public onAdd() {
        this.fbArray.push(new FormGroup({}));
    }

    public onRemove(index: number) {
        this.fbArray.removeAt(index);
    }
}
